<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Picking For Delivery" active>

                                <b-row v-if="hasFailedDataPickingForDelivery">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingForDelivery.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingForDeliverysFailed" :fields="fieldsPickingForDelivery" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingForDelivery" :sort-desc.sync="sortDescPickingForDelivery" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(pickingDate)="row">
													{{ row.item.pickingDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(startDate)="row">
													{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishDate)="row">
													{{ row.item.finishDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingForDelivery.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingForDeliverys" :fields="fieldsPickingForDelivery" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingForDelivery" :sort-desc.sync="sortDescPickingForDelivery" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(pickingDate)="row">
													{{ row.item.pickingDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(startDate)="row">
													{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishDate)="row">
													{{ row.item.finishDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Picking For Delivery Detail" active>

                                <b-row v-if="hasFailedDataPickingForDeliveryDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingForDeliveryDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingForDeliveryDetailsFailed" :fields="fieldsPickingForDeliveryDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingForDeliveryDetail" :sort-desc.sync="sortDescPickingForDeliveryDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(planQty)="row">
													{{ Number(row.item.planQty).toLocaleString() }}
												</template>
												<template #cell(actualQty)="row">
													{{ Number(row.item.actualQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingForDeliveryDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingForDeliveryDetails" :fields="fieldsPickingForDeliveryDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingForDeliveryDetail" :sort-desc.sync="sortDescPickingForDeliveryDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(planQty)="row">
													{{ Number(row.item.planQty).toLocaleString() }}
												</template>
												<template #cell(actualQty)="row">
													{{ Number(row.item.actualQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Picking Card Detail" active>

                                <b-row v-if="hasFailedDataPickingCardDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingCardDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingCardDetailsFailed" :fields="fieldsPickingCardDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingCardDetail" :sort-desc.sync="sortDescPickingCardDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(scanDate)="row">
													{{ row.item.scanDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingCardDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingCardDetails" :fields="fieldsPickingCardDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingCardDetail" :sort-desc.sync="sortDescPickingCardDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(scanDate)="row">
													{{ row.item.scanDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PickingForDelivery from '@/models/PickingForDelivery/PickingForDelivery';
import PickingForDeliveryList from '@/models/PickingForDelivery/PickingForDeliveryList';
import PickingForDeliveryFilter from '@/filters/PickingForDelivery/PickingForDeliveryFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPickingForDelivery: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction", key: 'deliveryInstructionDiNumber', sortable: false},
				{"class" : "th-status", "label" : "Picking Date", key: 'pickingDate', sortable: false},
				{"class" : "th-status", "label" : "Start Date", key: 'startDate', sortable: false},
				{"class" : "th-status", "label" : "Finish Date", key: 'finishDate', sortable: false},
				{"class" : "th-status", "label" : "Picking By", key: 'pickingByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Picking Status", key: 'pickingStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPickingForDeliveryDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Plan Qty", key: 'planQty', sortable: false},
				{"class" : "th-status", "label" : "Actual Qty", key: 'actualQty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPickingCardDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Picking Detail", key: 'pickingDetailDeliveryInstructionDetail', sortable: false},
				{"class" : "th-status", "label" : "Delivery Card", key: 'deliveryCardDeliveryCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Scan Date", key: 'scanDate', sortable: false},
				{"class" : "th-status", "label" : "Scan By", key: 'scanByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			pickingForDeliverys : [],
			pickingForDeliverysFailed: [],
			pickingForDeliveryId : '',
			sortByPickingForDelivery: '',
			sortDescPickingForDelivery: '',
			hasFailedDataPickingForDelivery: false,
			totalFailedPickingForDelivery: 0,
			totalSucceedPickingForDelivery: 0,
			pickingForDeliveryDetails : [],
			pickingForDeliveryDetailsFailed: [],
			pickingForDeliveryDetailId : '',
			sortByPickingForDeliveryDetail: '',
			sortDescPickingForDeliveryDetail: '',
			hasFailedDataPickingForDeliveryDetail: false,
			totalFailedPickingForDeliveryDetail: 0,
			totalSucceedPickingForDeliveryDetail: 0,

			pickingCardDetails : [],
			pickingCardDetailsFailed: [],
			pickingCardDetailId : '',
			sortByPickingCardDetail: '',
			sortDescPickingCardDetail: '',
			hasFailedDataPickingCardDetail: false,
			totalFailedPickingCardDetail: 0,
			totalSucceedPickingCardDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('pickingfordelivery/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('pickingfordelivery/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPickingForDeliveryForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPickingForDeliveryForUpload : async function() {
			let _this = this;
			this.$http.get('pickingfordelivery/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.pickingForDeliverys = [];
_this.pickingForDeliveryDetails = [];
_this.pickingCardDetails = [];


					if (response != null) {
						let result = response.data;
						_this.pickingForDeliverys = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPickingForDelivery = _this.pickingForDeliverys.length;

						_this.pickingForDeliverysFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPickingForDelivery = true;
						_this.totalFailedPickingForDelivery = 0;
						if(_this.pickingForDeliverysFailed == undefined || _this.pickingForDeliverysFailed.length === 0) _this.hasFailedDataPickingForDelivery = false;
						if(_this.hasFailedDataPickingForDelivery) _this.totalFailedPickingForDelivery = _this.pickingForDeliverysFailed.length;
						_this.pickingForDeliveryDetails = [];
						_this.pickingForDeliveryDetailsFailed = [];
						_this.hasFailedDataPickingForDeliveryDetail = true;
						_this.totalSucceedPickingForDeliveryDetail = 0;
						result.forEach(function(element) {
							_this.pickingForDeliveryDetails.push(...element.pickingForDeliveryDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPickingForDeliveryDetail = _this.pickingForDeliveryDetails.length;

							_this.pickingForDeliveryDetailsFailed.push(...element.pickingForDeliveryDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.pickingForDeliveryDetailsFailed == undefined || _this.pickingForDeliveryDetailsFailed.length === 0) _this.hasFailedDataPickingForDeliveryDetail = false;
							if(_this.hasFailedDataPickingForDeliveryDetail) _this.totalFailedPickingForDeliveryDetail = _this.pickingForDeliveryDetailsFailed.length;
						});						_this.pickingCardDetails = [];
						_this.pickingCardDetailsFailed = [];
						_this.hasFailedDataPickingCardDetail = true;
						_this.totalSucceedPickingCardDetail = 0;
						result.forEach(function(element) {
							_this.pickingCardDetails.push(...element.pickingCardDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPickingCardDetail = _this.pickingCardDetails.length;

							_this.pickingCardDetailsFailed.push(...element.pickingCardDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.pickingCardDetailsFailed == undefined || _this.pickingCardDetailsFailed.length === 0) _this.hasFailedDataPickingCardDetail = false;
							if(_this.hasFailedDataPickingCardDetail) _this.totalFailedPickingCardDetail = _this.pickingCardDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'pickingfordelivery/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PickingForDelivery.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPickingForDelivery = new PickingForDeliveryFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
